import { TopBarConfig } from "./topBarFuncs";

export const topBarConfig: TopBarConfig = {
    home: {
        logo: "./logoLddConnect.svg",
        alt: "RW",
        showAppCode: true,
        logout: "/logout.asp",
        middleIcon: "./logoRealti.svg"
    },
    items: [
        {
            name: "Home",
            icon: "fa-solid fa-house fa-action",
            tooltip: "Home",
            action: "OpenMainPage",
        },
        {
            name: "Calendar1",
            icon: "fa-solid fa-calendar-days fa-indicator",
            tooltip: "Calendar",
            action: "OpenCalendarNew",
        },
        {
            name: "Inbox",
            icon: "fa-solid fa-inbox fa-indicator",
            tooltip: "The Inbox feature is currently not available for Training Site.",
            action: "",
            requiredField: {
                field: "IsCollege",
                value: "1",
            }
        },
        {
            name: "Inbox",
            icon: "fa-solid fa-inbox fa-indicator",
            tooltip: "Inbox",
            action: "OpenInbox",
            requiredField: {
                field: "IsCollege",
                value: "0",
            }
        },
        {
            name: "Notifications",
            placeholder: true,
            action: "OpenNotificationCenter",
            requiredField: {
                field: "IsCollege",
                value: "0",
            }
        },
        {
            name: "Notifications",
            icon: "fa-solid fa-bell fa-indicator",
            tooltip: "The Notifications feature is currently not available for Training Site.",
            action: "",
            requiredField: {
                field: "IsCollege",
                value: "1",
            }
        },
        {
            name: "Help",
            icon: "fa-solid fa-circle-question fa-indicator",
            tooltip: "Help",
            action: "handleHelpClick",
        },
        {
            name: "Settings",
            icon: "fa-solid fa-gear fa-indicator",
            tooltip: "Settings",
            placeholder: true,
            action: "OpenSettings",
        },
    ],
    account: {
        icon: "avatar",
        tooltip: "Account",
        popoverItems: [
            {
                label: "My Profile",
                icon: "fa-solid fa-circle-user",
                action: "OpenUserProfile",
            },
            {
                label: "Update Password",
                icon: "fa-solid fa-unlock",
                action: "OpenPasswordUpdate",
            },
            {
                label: "My Connected Accounts",
                icon: "fa-solid fa-link",
                action: "OpenUserSettings",
            },
            {
                label: "Preferences",
                icon: "fa-solid fa-sliders",
                action: "OpenUserPreferences",
            },
            {
                label: "Dark Theme",
                icon: "fa-solid fa-moon",
                type: "switch",
                action: null,
                switchProps: {
                    id: "dark-mode-switch",
                    ariaLabel: "Check this switch",
                    defaultChecked: "isDarkTheme",
                    action: "toggleDarkTheme",
                },
            },
        ],
    },
};
